import React from 'react';
import {
  Snackbar,
  Alert as MuiAlert,
  Zoom
} from '@mui/material';

const NotificationSnackbar = ({ snackbar, onClose }) => {
  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      TransitionComponent={Zoom}
      sx={{ marginTop: 2 }}
    >
      <MuiAlert
        onClose={onClose}
        severity={snackbar.severity}
        variant="filled"
        elevation={6}
        sx={{
          width: '100%',
          minWidth: '300px',
          fontWeight: 500,
          borderRadius: '8px',
          boxShadow: '0 8px 16px rgba(0,0,0,0.15)',
          padding: '10px 16px',
          '.MuiAlert-icon': {
            fontSize: '1.4rem',
            marginRight: '12px',
          },
          '.MuiAlert-message': {
            fontSize: '0.95rem',
            display: 'flex',
            alignItems: 'center',
            fontFamily: (theme) => theme.typography.fontFamily,
          },
          '.MuiAlert-action': {
            paddingTop: '4px',
          },
          border: (theme) => `1px solid ${theme.palette[snackbar.severity]?.light || theme.palette.info.light}`,
          backdropFilter: 'blur(8px)',
        }}
      >
        {snackbar.message}
      </MuiAlert>
    </Snackbar>
  );
};

export default NotificationSnackbar; 